var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 27,
    viewBox: "0 0 201 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_1725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8501 0C17.33 0.752852 15.4044 1.77947 13.3438 3.25095C15.7085 4.89354 17.5664 6.57034 18.8839 7.90494C22.9715 12.0456 25.3362 16.2548 26.6874 19.0951V7.90494L18.8501 0Z",
    fill: "url(#paint0_linear_28_1725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6538 19.095C25.9444 17.5551 24.8972 15.6046 23.4446 13.4829C21.823 15.8783 20.1677 17.7604 18.8503 19.095C14.7627 23.2357 10.6076 25.6312 7.80371 27H18.8503L26.6538 19.095Z",
    fill: "url(#paint1_linear_28_1725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3099 23.749C10.9452 22.1065 9.08723 20.4297 7.76975 19.0951C3.71597 14.9544 1.35126 10.7452 0 7.90494V19.0951L7.80353 27C9.3237 26.2471 11.2492 25.2205 13.3099 23.749Z",
    fill: "url(#paint2_linear_28_1725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20924 13.4829C4.83076 11.0875 6.48605 9.20532 7.80353 7.87072C11.8911 3.76426 16.0124 1.36882 18.8501 0H7.80353L0 7.90494C0.743193 9.44487 1.75664 11.3954 3.20924 13.4829Z",
    fill: "url(#paint3_linear_28_1725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6358 22.3802L94.6021 10.5399L88.8254 20.327H87.3728L81.5962 10.6768V22.346H78.4883V4.51712H81.1908L88.1836 16.3574L95.0412 4.51712H97.7437L97.7775 22.3802H94.6358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.655 18.2396H104.838L103.115 22.3802H99.7368L107.675 4.51712H110.885L118.823 22.3802H115.411L113.655 18.2396ZM112.574 15.6388L109.263 7.83651L105.953 15.6388H112.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.37 22.3802L128.755 17.1445C128.62 17.1445 128.383 17.1787 128.079 17.1787H124.093V22.3802H120.816V4.51712H128.079C129.6 4.51712 130.951 4.75666 132.066 5.26997C133.214 5.78328 134.059 6.50191 134.667 7.46009C135.275 8.41826 135.579 9.54754 135.579 10.8479C135.579 12.1825 135.241 13.346 134.599 14.3042C133.957 15.2624 133.012 15.981 131.829 16.4601L135.883 22.3118H132.37V22.3802ZM131.187 8.24716C130.444 7.63119 129.363 7.3232 127.944 7.3232H124.127V14.4411H127.944C129.363 14.4411 130.444 14.1331 131.187 13.5171C131.931 12.9012 132.302 12.0114 132.302 10.8821C132.302 9.75286 131.931 8.86313 131.187 8.24716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.038 14.8859L142.234 17.7947V22.346H138.957V4.51712H142.234V13.6882L150.949 4.55134H154.632L147.234 12.5247L155.071 22.3802H151.254L145.038 14.8859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.306 19.5742V22.346H157.098V4.51712H169.935V7.28898H160.341V11.943H168.854V14.6806H160.341V19.6084H170.306V19.5742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.266 7.3232H171.421V4.51712H186.387V7.3232H180.542V22.3802H177.266V7.3232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.933 22.038C188.65 21.6616 187.67 21.1141 186.927 20.4981L188.075 17.9316C188.785 18.5133 189.697 18.9924 190.744 19.3346C191.791 19.711 192.839 19.8821 193.886 19.8821C195.203 19.8821 196.183 19.6768 196.825 19.2319C197.467 18.8213 197.804 18.2395 197.804 17.5551C197.804 17.0418 197.636 16.6312 197.264 16.289C196.892 15.9468 196.453 15.7072 195.879 15.5019C195.338 15.3308 194.561 15.0913 193.615 14.8517C192.264 14.5437 191.183 14.2015 190.372 13.8935C189.528 13.5856 188.819 13.0722 188.244 12.3878C187.636 11.7034 187.366 10.7795 187.366 9.58175C187.366 8.58935 187.636 7.69962 188.143 6.87833C188.683 6.05704 189.46 5.44107 190.541 4.96198C191.622 4.48289 192.906 4.24335 194.46 4.24335C195.541 4.24335 196.588 4.38023 197.636 4.65399C198.683 4.92776 199.561 5.30418 200.338 5.81749L199.291 8.38403C198.514 7.93916 197.703 7.56274 196.859 7.32319C196.014 7.08365 195.203 6.98099 194.426 6.98099C193.143 6.98099 192.163 7.18631 191.555 7.63118C190.913 8.07605 190.609 8.6578 190.609 9.37643C190.609 9.88973 190.778 10.3004 191.149 10.6084C191.521 10.9164 191.96 11.1901 192.535 11.3612C193.075 11.5323 193.852 11.7719 194.798 12.0114C196.115 12.3194 197.196 12.6274 198.007 12.9696C198.852 13.3118 199.561 13.7909 200.169 14.4753C200.777 15.1597 201.047 16.0837 201.047 17.2129C201.047 18.2053 200.777 19.0951 200.27 19.8821C199.73 20.6692 198.953 21.3194 197.872 21.7985C196.791 22.2776 195.473 22.5171 193.953 22.5171C192.534 22.6198 191.217 22.4144 189.933 22.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6789 21.5589C56.2263 20.7718 55.0778 19.6768 54.267 18.2737C53.4563 16.8707 53.0171 15.2966 53.0171 13.5855C53.0171 11.8403 53.4225 10.2661 54.267 8.89732C55.0778 7.49428 56.2263 6.39922 57.6789 5.61215C59.1315 4.82508 60.7868 4.41443 62.611 4.41443C64.4352 4.41443 66.0568 4.82508 67.5094 5.61215C68.962 6.39922 70.1105 7.49428 70.9213 8.89732C71.7658 10.3004 72.1712 11.8745 72.1712 13.5855C72.1712 15.3308 71.7658 16.9049 70.9213 18.2737C70.0767 19.6768 68.9282 20.7718 67.5094 21.5589C66.0568 22.346 64.4352 22.7566 62.611 22.7566C60.7868 22.7566 59.1315 22.3802 57.6789 21.5589ZM65.4149 18.5475C66.2594 18.0684 66.9013 17.384 67.3742 16.5285C67.8472 15.673 68.0836 14.6806 68.0836 13.5855C68.0836 12.4905 67.8472 11.4981 67.3742 10.6426C66.9013 9.78705 66.2594 9.10264 65.4149 8.62355C64.5704 8.14447 63.6583 7.90492 62.611 7.90492C61.5638 7.90492 60.6517 8.14447 59.8072 8.62355C58.9626 9.10264 58.3208 9.78705 57.8478 10.6426C57.3749 11.4981 57.1384 12.4905 57.1384 13.5855C57.1384 14.6806 57.3749 15.673 57.8478 16.5285C58.3208 17.384 58.9626 18.0684 59.8072 18.5475C60.6517 19.0266 61.5638 19.2661 62.611 19.2661C63.6245 19.2661 64.5704 19.0266 65.4149 18.5475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2205 13.2433C45.0784 13.7909 46.4973 14.6464 47.6796 15.5019V18.5133C46.7337 19.0266 45.6865 19.2661 44.5379 19.2661C43.4231 19.2661 42.4435 19.0266 41.5989 18.5475C40.7544 18.0684 40.0788 17.384 39.5721 16.5285C39.0991 15.673 38.8626 14.6806 38.8626 13.5855C38.8626 12.4563 39.0991 11.4981 39.5721 10.6084C40.045 9.75284 40.7206 9.06843 41.5989 8.58934C42.4773 8.11026 43.4569 7.87071 44.5717 7.87071C46.3284 7.87071 47.8485 8.55512 49.0984 9.88972L51.6996 7.46007C50.8551 6.46767 49.8079 5.71482 48.5579 5.16729C47.308 4.65398 45.923 4.38022 44.369 4.38022C42.5448 4.38022 40.8895 4.75664 39.4031 5.54372C37.9505 6.33079 36.802 7.42585 35.9574 8.82889C35.1467 10.2319 34.7075 11.8061 34.7075 13.5513C34.7075 15.2966 35.1129 16.8707 35.9574 18.2738C36.7682 19.6768 37.9168 20.7719 39.3694 21.5589C40.822 22.346 42.4435 22.7224 44.2677 22.7224C45.5514 22.7224 46.8013 22.5171 48.0512 22.1407C49.3011 21.7642 50.3821 21.2167 51.328 20.4981V19.0266V13.3118V13.2776L51.2942 13.2433H43.2205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_1725",
    x1: 14.147,
    y1: 2.23898,
    x2: 29.8328,
    y2: 15.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000340545,
    stopColor: "#08804A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#0A9648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5435,
    stopColor: "#0BA547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#0BAB47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_1725",
    x1: 22.8575,
    y1: 13.1477,
    x2: 12.989,
    y2: 30.0211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000340545,
    stopColor: "#08804A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#0A9648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5435,
    stopColor: "#0BA547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#0BAB47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_1725",
    x1: 7.14884,
    y1: 27.0446,
    x2: 5.40993,
    y2: 7.42386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000340545,
    stopColor: "#08804A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#0A9648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5435,
    stopColor: "#0BA547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    stopColor: "#0BAB47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_1725",
    x1: 5.66425,
    y1: 14.4074,
    x2: 11.9172,
    y2: -2.55204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000340545,
    stopColor: "#08804A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#0A9648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4714,
    stopColor: "#0BA547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6611,
    stopColor: "#0BAB47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#12B24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#26C759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9639,
    stopColor: "#2BCC5C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_1725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLogo);
export default __webpack_public_path__ + "static/media/go-logo.5e31044bf6a21ef74751aaf3ceff84ac.svg";
export { ForwardRef as ReactComponent };